interface Header{
    name : string,
    type : string,
    email : string
}

export class HeaderAdapter {
    value: any;

    constructor(input: any) {
        (this.value = input.params ||  input.param);
        console.log("this.value", this.value);
    }

    get name(){
        if(window.location.pathname.includes("searchers")){
            return this.value.name || ''
        }

        if(window.location.pathname.includes("commons")){
            return this.value.name || ''
        }

        if(window.location.pathname.includes("entities")){
            return  this.value?.name  || ''
        }

        if(window.location.pathname.includes("groups")){
            return   this.value?.name || ''
        }

        if(window.location.pathname.includes("universities")){
            return  this.value?.name || ''
        }

        if(window.location.pathname.includes("capacities")){
            return  this.value?.name || ''
        }

        if(window.location.pathname.includes("products")){
            return  this.value?.name || ''
        }
        
        return ''
    }

    get type(){
        
        if(window.location.pathname.includes("entities")){
            return  this.value.type?.actor  || this.value.type || '' 
        }

        if(window.location.pathname.includes("commons")){
            return this.value.type.actor || this.value.type || ''
        }

        if(window.location.pathname.includes("searchers")){
            return this.value.type.actor || this.value.type || '';
        }

        if(window.location.pathname.includes("groups")){
            return  this.value.type.actor || this.value.type || ''
        }

        if(window.location.pathname.includes("universities")){
            return  this.value?.type?.actor || this.value.type || ''
        }

        if(window.location.pathname.includes("products")){
            return  this.value?.type?.actor || this.value.type || '';
        }

        if(window.location.pathname.includes("capacities")){
            return  this.value?.type?.actor || this.value.type || ''
        }

        return ''
    }

    adapt(): Header{
        return {
            name : this.name,
            type : this.type,
            email : this.value.contact_email
        }
    }
}